<template>
  <v-icon
    size="32"
    icon="mdi-close"
    variant="text"
    class="close-button float-right mt-4 mr-4"
    :disabled="processing"
    @click="click"
    @touchend="click"
  />
</template>

<script>
import { useI18n } from 'vue-i18n';
export default {
  name: 'DialogCloseButton',
  props: {
    color: {
      type: String,
      default: null,
    },
  },
  setup() {
    const { t } = useI18n()
    return {
      t,
    }
  },
  data() {
    return {
      processing: false,
    }
  },
  methods: {
    click() {
      if (this.processing === true) {
        return
      }
      this.processing = true
      setTimeout(() => {
        this.processing = false
      }, 500)
      this.$emit('click')
    },
  },
}
</script>

<style scoped>
.close-button {
  opacity: 1;
}
</style>